import {IVanillaReaderUI} from "./IVanillaReaderUI";
import {VanillaReaderUiMenuMediaPlayerController} from "./VanillaReaderUiMenuMediaPlayerController";
import {IVanillaReaderUiComponentController} from "./IVanillaReaderUiComponentController";
import {VanillaReaderUI} from "./VanillaReaderUI";
import { IVanillaReaderAppEvent_NAVIGATION_INTENT } from "../VanillaReaderEventBus/IVanillaReaderAppEventTypeMap";

export interface VanillaReaderUiSideMenuController extends IVanillaReaderUiComponentController, IVanillaReaderUI, VanillaReaderUiMenuMediaPlayerController {}

/**
 * # VanillaReaderUiMenuController
 *
 * ## RESPONSIBILITIES
 * This controller mixing class handles all event callbacks from the `VanillaReaderUiMenu` class.
 *
 * Just as all other controller mixin classes, this class is used to add functionality to the `VanillaReaderUi` class
 * in a "modular" way. Read more about this in the `UI Components and Controller Mixins` in the README.md file.
 *
 * ## RELATED TYPES
 * - VanillaReaderUi
 * - VanillaReaderUiMenu
 *
 */
export class VanillaReaderUiSideMenuController {

    static __initialize__(vanillaReaderUiContext: VanillaReaderUI): void {
        vanillaReaderUiContext.menuSide.onMenuHandleClicked(vanillaReaderUiContext._onMenuBottomHandleClicked.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuSide.onMenuHandleSwipeDown(vanillaReaderUiContext._onMenuBottomHandleClicked.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuSide.onMenuVisible(vanillaReaderUiContext._onMenuBottomVisible.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuSide.onMenuHidden(vanillaReaderUiContext._onMenuBottomHidden.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuSide.onNavItemClicked(vanillaReaderUiContext._onDialogContentsNavigationItemClicked.bind(vanillaReaderUiContext));

        vanillaReaderUiContext.menuSide.onSearchExecute(vanillaReaderUiContext._onDialogSearchExecute.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuSide.onSearchClear(vanillaReaderUiContext._onDialogSearchClear.bind(vanillaReaderUiContext));
    }

    _onMenuBottomHandleClicked(): void {
        this.menuSide.hide(!this.useReducedMotion);
    };

    _onMenuBottomVisible(): void {
        this.menuSide.setAsImportantForAccessibility();
        this.setReaderViewAsNotImportantForAccessibility();
    };

    _onMenuBottomHidden(): void {
        this.menuSide.setAsNotImportantForAccessibility();
        this.setReaderViewAsImportantForAccessibility();
        this.focusOnReadingPosition();
    };

    _onDialogContentsNavigationItemClicked(navigationData: IVanillaReaderAppEvent_NAVIGATION_INTENT): void {
        if (navigationData.locator) {
            this.navigateTo(navigationData.locator.toString());
        }

        this.menuSide.hide();
        this.dialogContents?.close(true,false);
    };

    _onDialogSearchExecute(searchTerm: string): void {
        this.dialogSearch.show();
        this.dialogSearch.setSearchTerm(searchTerm);
        this.searchPublication(searchTerm);
    };

    _onDialogSearchClear(): void {
        this.vanillaReaderAPI?.clearPublicationSearchLayer();
        this.toaster.toast('Search results cleared', true).catch(console.warn);
        this.latestSelectedSearchResultLocator = undefined;
    };

}
